import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import defaultsDeep from 'lodash/defaultsDeep';
import accounting from 'accounting';
import Config from '@/config';

const numberOptions = {
  decimal: Config.get('NUMBER_DECIMAL'),
  thousand: Config.get('NUMBER_THOUSAND'),
};

accounting.settings = defaultsDeep({
  currency: {
    symbol: Config.get('MONEY_SYMBOL'),
    format: Config.get('MONEY_FORMAT'),
    ...numberOptions,
    precision: 0,
  },
  number: {
    ...numberOptions,
  },
}, accounting.settings);

export function formatMoney(data, currency = 1) {
  switch(currency) {
    case 1:
      return accounting.formatMoney(data);
    case 2:
      return accounting.formatMoney(data, { symbol: '$', format: '%s%v' });
  }
}

export const parseAmount = amount => isString(amount) ? Number(amount) : amount;

export function formatNumber(amount, opts) {
  const parsedAmount = parseAmount(amount);

  if(!isNumber(parsedAmount)) return parsedAmount;

  return accounting.formatNumber(parsedAmount, opts);
}
